import React from 'react';

import { Box, VStack, Link as ChakraLink, Flex, Text } from '@chakra-ui/react';

import { useModalContext } from '../../../ModalProvider/hooks/useModalContext';
import { EColor } from '../../../Theme';
import { maxWidths } from '../../../utilities';
import { getLink } from '../../utils/monolithUrls';

const defaultAuctionLinks = (fanaticsCollectBaseUrl: string) => {
  return [
    {
      group: 'Sports cards',
      options: [
        {
          label: 'Baseball',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Sports Cards > Baseball',
          }),
        },
        {
          label: 'Basketball',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Sports Cards > Basketball',
          }),
        },
        {
          label: 'Football',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Sports Cards > Football',
          }),
        },
        {
          label: 'Soccer',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Sports Cards > Soccer',
          }),
        },
      ],
      viewAllLink: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
        categoryGroup: 'Sports Cards',
      }),
    },
    {
      group: 'Trading cards',
      options: [
        {
          label: 'Pokémon',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category:
              'Trading Card Games > Pokémon (Other Languages),Trading Card Games > Pokémon (English),Trading Card Games > Pokémon (Japanese)',
          }),
        },
        {
          label: 'Yu-Gi-Oh!',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Trading Card Games > Yu-gi-oh!',
          }),
        },
        {
          label: 'Magic The Gathering',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Trading Card Games > Magic The Gathering',
          }),
        },
        {
          label: 'Collectible Card Games',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Trading Card Games > Collectible Card Games',
          }),
        },
      ],
      viewAllLink: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
        categoryGroup: 'Trading Card Games',
      }),
    },
    {
      group: 'Other',
      options: [
        {
          label: 'Wax',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Other > Wax',
          }),
        },
        {
          label: 'Comics',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            categoryGroup: 'Comics',
          }),
        },
        {
          label: 'Memorabilia',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            category: 'Other > Memorabilia',
          }),
        },
        {
          label: 'Video Games',
          link: getLink(fanaticsCollectBaseUrl, 'weeklySRP', {
            categoryGroup: 'Video Games',
          }),
        },
        {
          label: 'Sold items',
          link: getLink(fanaticsCollectBaseUrl, 'salesHistory'),
        },
      ],
    },
  ];
};
const defaultBuyNowLinks = (fanaticsCollectBaseUrl: string) => {
  return [
    {
      group: 'Sports cards',
      options: [
        {
          label: 'Baseball',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Sports Cards > Baseball',
          }),
        },
        {
          label: 'Basketball',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Sports Cards > Basketball',
          }),
        },
        {
          label: 'Football',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Sports Cards > Football',
          }),
        },
        {
          label: 'Soccer',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Sports Cards > Soccer',
          }),
        },
      ],
      viewAllLink: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
        categoryGroup: 'Sports Cards',
      }),
    },
    {
      group: 'Trading cards',
      options: [
        {
          label: 'Pokémon',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category:
              'Trading Card Games > Pokémon (Other Languages),Trading Card Games > Pokémon (English),Trading Card Games > Pokémon (Japanese)',
          }),
        },
        {
          label: 'Yu-Gi-Oh!',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Trading Card Games > Yu-gi-oh!',
          }),
        },
        {
          label: 'Magic The Gathering',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Trading Card Games > Magic The Gathering',
          }),
        },
        {
          label: 'Collectible Card Games',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Trading Card Games > Collectible Card Games',
          }),
        },
      ],
      viewAllLink: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
        categoryGroup: 'Trading Card Games',
      }),
    },
    {
      group: 'Other',
      options: [
        {
          label: 'Wax',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Other > Wax',
          }),
        },
        {
          label: 'Comics',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            categoryGroup: 'Comics',
          }),
        },
        {
          label: 'Memorabilia',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            category: 'Other > Memorabilia',
          }),
        },
        {
          label: 'Video Games',
          link: getLink(fanaticsCollectBaseUrl, 'fixedSRP', {
            categoryGroup: 'Video Games',
          }),
        },
        {
          label: 'Sold items',
          link: getLink(fanaticsCollectBaseUrl, 'salesHistory'),
        },
      ],
    },
  ];
};
const defaultPremierLinks = (fanaticsCollectBaseUrl: string) => {
  return [
    {
      group: 'Sports cards',
      options: [
        {
          label: 'Baseball',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Sports Cards > Baseball',
          }),
        },
        {
          label: 'Basketball',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Sports Cards > Basketball',
          }),
        },
        {
          label: 'Football',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Sports Cards > Football',
          }),
        },
        {
          label: 'Soccer',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Sports Cards > Soccer',
          }),
        },
      ],
      viewAllLink: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
        categoryGroup: 'Sports Cards',
      }),
    },
    {
      group: 'Trading cards',
      options: [
        {
          label: 'Pokémon',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category:
              'Trading Card Games > Pokémon (Other Languages),Trading Card Games > Pokémon (English),Trading Card Games > Pokémon (Japanese)',
          }),
        },
        {
          label: 'Yu-Gi-Oh!',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Trading Card Games > Yu-gi-oh!',
          }),
        },
        {
          label: 'Magic The Gathering',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Trading Card Games > Magic The Gathering',
          }),
        },
        {
          label: 'Collectible Card Games',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Trading Card Games > Collectible Card Games',
          }),
        },
      ],
      viewAllLink: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
        categoryGroup: 'Trading Card Games',
      }),
    },
    {
      group: 'Other',
      options: [
        {
          label: 'Wax',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Other > Wax',
          }),
        },
        {
          label: 'Comics',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            categoryGroup: 'Comics',
          }),
        },
        {
          label: 'Memorabilia',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            category: 'Other > Memorabilia',
          }),
        },
        {
          label: 'Video Games',
          link: getLink(fanaticsCollectBaseUrl, 'premierSRP', {
            categoryGroup: 'Video Games',
          }),
        },
        {
          label: 'Sold items',
          link: getLink(fanaticsCollectBaseUrl, 'salesHistory'),
        },
      ],
    },
  ];
};

interface DefaultMarketplaceMenuContentProps {
  type: 'auctions' | 'buyNow' | 'premier';
  trackAndClose: (title: string) => void;
}

export const DefaultMarketplaceMenuContent = ({
  type,
  trackAndClose,
}: DefaultMarketplaceMenuContentProps) => {
  const { fanaticsCollectBaseUrl } = useModalContext();
  return (
    <Box
      display="flex"
      flexDir="column"
      gap={4}
      maxWidth={maxWidths}
      mx="auto"
      px="8px"
      py="20px"
    >
      <Flex alignItems="center" justifyContent="space-between" width="full">
        <Text color="neutral.950" fontSize="lg" fontWeight="bold">
          Browse by Category
        </Text>
        <ChakraLink
          fontSize="sm"
          fontWeight="bold"
          href={getLink(
            fanaticsCollectBaseUrl,
            type === 'auctions'
              ? 'weeklySRP'
              : type === 'buyNow'
              ? 'fixedSRP'
              : 'premierSRP'
          )}
          textDecoration="underline"
          onClick={() => trackAndClose('View All Categories')}
        >
          View all categories
        </ChakraLink>
      </Flex>
      <Flex width="100%">
        <Flex flexDirection="row" justifyContent="space-between" width="100%">
          {(type === 'auctions'
            ? defaultAuctionLinks
            : type === 'buyNow'
            ? defaultBuyNowLinks
            : defaultPremierLinks)(fanaticsCollectBaseUrl).map(
            ({ group, options, viewAllLink }) => {
              return (
                <VStack
                  align="stretch"
                  gap="0"
                  key={group}
                  minWidth="200px"
                  width="100%"
                >
                  <Box color={EColor.Neutral700} fontWeight="bold" py="14px">
                    {group}
                  </Box>
                  {options.map(({ label, link }) => (
                    <ChakraLink
                      _active={{ bg: EColor.Neutral200, color: EColor.Black }}
                      _hover={{ bg: EColor.Neutral101, color: EColor.Black }}
                      color={EColor.Neutral950}
                      fontSize="sm"
                      href={link}
                      key={label}
                      margin="0 !important"
                      px="4px"
                      py="10px"
                      onClick={() => trackAndClose(label)}
                    >
                      {label}
                    </ChakraLink>
                  ))}
                  {viewAllLink && (
                    <ChakraLink
                      _hover={{ textDecoration: 'none', color: EColor.Black }}
                      fontSize="sm"
                      fontWeight="bold"
                      href={viewAllLink}
                      px="4px"
                      py="10px"
                      textDecoration="underline"
                      onClick={() => trackAndClose(`View All ${group}`)}
                    >
                      View all
                    </ChakraLink>
                  )}
                </VStack>
              );
            }
          )}
        </Flex>
      </Flex>
    </Box>
  );
};
